
import GuidanceMixin from '~/mixins/guidance'

export default {
    mixins: [GuidanceMixin],
    computed: {
        // Use dobx age properties if available, fallback to manual age group
        is_under_65 () {
            if (this.dobx?.age !== undefined) {
                return this.lt65
            }
            return this.survey?.age_group === 'UNDER_65'
        },
        is_turning_65 () {
            if (this.dobx?.age !== undefined) {
                return this.t65
            }
            return this.survey?.age_group === 'TURNING_65'
        },
        is_over_65 () {
            if (this.dobx?.age !== undefined) {
                return this.gte65
            }
            return this.survey?.age_group === 'OVER_65'
        },
    }
}
